import Vue from 'vue'
import App from './App.vue'
import router from './router';
import vuetify from '@/plugins/vuetify' // path to vuetify export
var VueScrollTo = require('vue-scrollto');
import EnlargeableImage from '@diracleo/vue-enlargeable-image';
import firebase from 'firebase/app'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_KEY,
  authDomain: process.env.VUE_APP_DOMAIN,
  projectId: process.env.VUE_APP_PROJID,
  storageBucket: process.env.VUE_APP_STOR,
  messagingSenderId: process.env.VUE_APP_SENDER,
  appId: process.env.VUE_APP_APPID,
  measurementId: process.env.VUE_APP_MEASE
};

firebase.initializeApp(firebaseConfig);

Vue.use(VueScrollTo)
Vue.use(EnlargeableImage)
// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

import Hub from './layouts/Hub.vue';
Vue.component('hub-layout', Hub);

import './assets/scss/main.scss';

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App),
  components: {
  }
}).$mount('#app')
